import React from 'react';

import classes from './ScrollDownButton.module.css';

const scrollDownButton = (props) => (
  <svg className={classes.ScrollDownButton} onClick={props.clicked}>
    <use xlinkHref='/sprites.svg#icon-scroll-up' />
  </svg>
);

export default scrollDownButton;
